import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ExperienceCard from "./ExperienceCards";
import Particle from "../Particle";
import seitech from "../../Assets/Companies/Seitech.jpg";
import avidbeam from "../../Assets/Companies/avidbeam.png";
import devisionx from "../../Assets/Companies/devisionx.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Work Experience </strong>
        </h1>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={5} className="project-card">
            <ExperienceCard
              imgPath={seitech}
              period="Aug 2022 – Oct 2022"
              title="DevOps Engineer Intern"
              description={['Successfully created and maintained automated CI/CD pipelines for code development using Jenkins while automating the deployment process, resulting in the elimination of 70% of manual work and escalation of work efficiency.','Monitored the deployments in production using Prometheus and Grafana.','Used Jenkins to automate build and deployment that reduced human error and sped up production processes.', 'Automated infrastructure creation on the cloud using Terraform.', 'Built a RESTFul API using Python and FastAPI to manage the infrastructure in the cloud.']}
             
            />
          </Col>

          <Col md={5} className="project-card">
            <ExperienceCard
              imgPath={avidbeam}
              period="Oct 2021 – Dec 2021"
              title="Full-Stack Developer Intern"
              description={['Wrote functional, unit, and integration tests for application quality assurance using Rspec.', 'Used version control tool Git and code storage tool Gitlab for added application functionality.', 'Implemented a background task for retrieving data from the database in CSV format using Sidekiq in Ruby language.', 'Built new user interface components using ReactJs and Ant Design library.']}
             
            />
          </Col>

          <Col md={5} className="project-card">
            <ExperienceCard
              imgPath={devisionx}
              period="Sept 2020 – Nov 2020"
              title="Software Engineer Intern"
              description={['Built fully automated CI/CD pipelines on Gitlab CI/CD and Jenkins for containerized applications using Docker and AWS EC2.', 'Partnered with a machine learning engineer to implement RESTful APIs in Flask, enabling the AI team to expose their models.', 'Customized an annotation tool (Universal Data Tool) based on needs using ReactJs.']}
             
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
